import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#434345] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_tailored-homes/artifacts/fbkk3i2e_BESPOKE-1.pdf"
                alt="Bespoke Realty"
                className="h-12 w-auto"
              />
              <img 
                src="https://customer-assets.emergentagent.com/job_tailored-homes/artifacts/0469dy7q_Beau.png"
                alt="Beau the Hummingbird"
                className="h-8 w-auto"
              />
            </div>
            <p className="text-sm text-gray-300 font-semibold mb-2">
              Services Tailored to You
            </p>
            <p className="text-sm text-gray-300">
              Black-owned, woman-led boutique brokerage serving Mississippi, Tennessee, and Arkansas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/buy" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">Buy a Home</Link></li>
              <li><Link to="/sell" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">Sell a Home</Link></li>
              <li><Link to="/new-construction" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">New Construction</Link></li>
              <li><Link to="/property-management" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">Property Management</Link></li>
              <li><Link to="/agents" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">Our Agents</Link></li>
              <li><a href="https://mstn-guide.emergent.host" target="_blank" rel="noopener noreferrer" className="text-sm text-[#BCA480] hover:text-white transition-colors font-medium">📖 Free Real Estate Guide</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">About Us</Link></li>
              <li><Link to="/apply" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">Join Our Team</Link></li>
              <li><Link to="/blog" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-300 hover:text-[#BCA480] transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-gray-300">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="font-semibold">Bespoke Realty</div>
                  <div>7927 Players Forest Drive</div>
                  <div>Memphis, TN 38119</div>
                </div>
              </li>
              <li className="flex items-start space-x-2 text-sm text-gray-300">
                <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <div>
                  <div>Office: <a href="tel:9013904414" className="hover:text-[#BCA480]">901-390-4414</a></div>
                </div>
              </li>
              <li className="flex items-start space-x-2 text-sm text-gray-300">
                <Clock className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <div>
                  <div>Mon-Fri: 10:30 AM - 4:30 PM</div>
                  <div>Sat-Sun: By Appointment</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Licensing Information */}
        <div className="border-t border-gray-600 mt-8 pt-6 text-center text-sm text-gray-400">
          <p className="mb-2">MS License #24018 | TN License #266066 | AR Principal Broker License #PB000099531</p>
          <div className="mb-2 flex flex-wrap justify-center gap-x-4 gap-y-1">
            <Link to="/privacy" className="hover:text-[#BCA480] transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <span aria-hidden="true">·</span>
            <Link to="/terms" className="hover:text-[#BCA480] transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
          </div>
          <p>&copy; {new Date().getFullYear()} Bespoke Realty. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
